import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import SaveIcon from '@mui/icons-material/Save';
import { Button, Stack, TextField } from '@mui/material';
import React, { useState } from 'react';
import { LoadingAnimationModal } from '../../../../../Popup/Loading';
import { ConsumerDao } from '../../../../../data/ConsumerDAO';
const HNotesTab = ({ device }) => {
    const [saving, setSaving] = useState(false);
    const [origin, setOrigin] = useState(device?.notes);
    const [notes, setNotes] = useState(device?.notes);
    const saveNotes = () => {
        if (device && notes) {
            setSaving(true);
            ConsumerDao.save({ ...device, notes }).then((res) => {
                setOrigin(notes);
                setSaving(false);
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, { gap: 1, children: [_jsx(TextField, { label: 'Notes', value: notes || '', onChange: (e) => setNotes(e.target.value), variant: "outlined", autoComplete: "off", minRows: 6, maxRows: 16, multiline: true, fullWidth: true }), _jsx(Stack, { direction: "row-reverse", children: _jsx(Button, { variant: "contained", disabled: notes === origin, startIcon: _jsx(SaveIcon, {}), onClick: saveNotes, children: "Save" }) })] }), saving && _jsx(LoadingAnimationModal, {})] }));
};
export default HNotesTab;
